import { FlexBoxView } from '@play-co/timestep-core/flexbox';
import ButtonScaleViewWithText from 'src/lib/ui/components/ButtonScaleViewWithText';
import uiConfig from 'src/lib/ui/config';
import { Container } from '../../../odie';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';
const ui = uiConfig.buttons;

type EditorSubMenuOpts = {
  width: number;
  height: number;
  title: string;
  buttons: Record<string, () => void>;
};

export class EditorSubMenu extends Container {
  constructor(opts: EditorSubMenuOpts) {
    super();

    this.width = opts.width;

    const flex = new FlexBoxView({
      superview: this.view,
      width: this.width,
      flex: {
        justifyContent: 'flex-start',
        alignItems: 'center',
        flexDirection: 'column',
      },
    });

    new LangBitmapFontTextView({
      superview: flex,
      width: this.width,
      height: 20,
      localeText: () => opts.title,
      font: 'Title',
      align: 'center',
      verticalAlign: 'center',
      size: 20,
    });

    for (const [label, onClick] of Object.entries(opts.buttons)) {
      new ButtonScaleViewWithText({
        ...ui.cancel,
        font: 'Body',
        width: this.width,
        height: 50,
        labelOffsetY: -1,
        superview: flex,
        localeText: () => label,
        fontSize: 20,
        onClick: async () => onClick(),
        tracking: {
          feature: 'editor',
          $subFeature: label,
        },
      });
    }
  }
}
